import React from "react"
import { Link, useLocation } from "react-router-dom"
import "./SignInPrompt.css"

/**
 * Modal prompting the user to sign in (e.g. to save a search, save a home, apply, or book).
 * Sign-in link includes redirect back to current page.
 */
export default function SignInPrompt({ message = "Sign in to continue.", onClose }) {
  const location = useLocation()
  const redirect = encodeURIComponent((location.pathname || "") + (location.search || ""))

  return (
    <div className="signin-prompt-overlay" onClick={onClose} aria-hidden="true">
      <div className="signin-prompt-modal" onClick={(e) => e.stopPropagation()}>
        <div className="signin-prompt__header">
          <h3>Sign in required</h3>
          <button type="button" className="signin-prompt__close" onClick={onClose} aria-label="Close">
            &times;
          </button>
        </div>
        <p className="signin-prompt__message">{message}</p>
        <div className="signin-prompt__actions">
          <button type="button" className="signin-prompt__btn signin-prompt__btn--secondary" onClick={onClose}>
            Cancel
          </button>
          <Link to={`/signin?redirect=${redirect}`} className="signin-prompt__btn signin-prompt__btn--primary">
            Sign in
          </Link>
        </div>
      </div>
    </div>
  )
}
